module.exports = __webpack_public_path__ + "img/sce_p5_img_3.c16ac4ec.png";